export function pagenation(max) {
  //ページネーションの要素を取得
  const pagenation = document.querySelector('.js-pagenation');

  //URL取得
  const localurl = window.location.href;
  //URLのパラメータ取得
  const searchParams = new URLSearchParams(window.location.search);
  //現在のページ数
  let currentPage = Number(searchParams.get('page'));
  if (currentPage === null || currentPage < 1) {
    currentPage = 1;
  }

  //前後のページ取得
  const prevPage = currentPage > 1 ? currentPage - 1 : null;
  const nextPage = currentPage < max ? currentPage + 1 : null;

  //矢印取得
  // const prevArrow = pagenation.querySelector('.js-pagenation--prev');
  // const nextArrow = pagenation.querySelector('.js-pagenation--next');

  //ページリスト要素を取得
  const pageList = pagenation.querySelector('.js-pagenation--list');

  //URLのパラメーターを取得
  const updateParam = (url, page) => {
    const urlObj = new URL(url);
    if (page <= 1) {
      urlObj.searchParams.delete('page');
    } else {
      urlObj.searchParams.set('page', page);
    }
    return urlObj.toString();
  };

  //矢印の値を設定
  const arrow = () => {
    const prevArrow = document.createElement('a');
    prevArrow.classList.add('c-paginationType01_arrow--prev');

    const nextArrow = document.createElement('a');
    nextArrow.classList.add('c-paginationType01_arrow--next');
    if (prevPage === null) {
      prevArrow.classList.add('is-disable');
    } else {
      prevArrow.href = updateParam(localurl , prevPage);
    }
    if (nextPage === null) {
      nextArrow.classList.add('is-disable');
    } else {
      nextArrow.href = updateParam(localurl , nextPage);
    }

    pageList.before(prevArrow);
    pagenation.appendChild(nextArrow);
  }

  //ページアイテムを作成
  const pageItem = (val) => {
    let item = document.createElement('li');
    if(isNaN(val)) {
      item.textContent = val;
    } else {
      let link = updateParam(localurl , val);
      let className = val === currentPage ? 'is-current' : '';
      item.innerHTML = `<a href="${link}" class="${className}">${val}</a>`;
    }
    pageList.appendChild(item);
  }

  //ページナビを作成
  const pageNavi = () => {
    //表示する範囲
    const range = 2;

    //最大ページ数
    const total = max;

    let list = [];//空のlist
    list.push(currentPage); //現在のページを追加
    for (let index = 1; index <= range; index++) { //現在のページから2まで離れた数値を追加
      let prev = currentPage - index;
      list.unshift(prev);
      let next = currentPage + index;
      list.push(next);
    }
    list = list.filter(x => { // 1より大きく、総ページ数より小さいページだけを残す
      return x > 1 && x < total;
    })

    if ( currentPage - 1 > 2 ) { //最初の数値が1から2以上離れていたら「・・・」に修正
      list.splice(0, 1, '・・・');
    }
    if( total - currentPage > 2 ) { //最後の数値が総ページ数から2以上離れていたら「・・・」に修正
      list.splice(-1,1, '・・・');
    }
    if( total != 1 ) { //最大ページが1ページじゃない場合
      pageItem(1); //1ページ目
      for (let index = 0; index < list.length; index++) {
        const page = list[index];
        pageItem(page);
      }
      pageItem(total); //最終ページ
    }
  }

  //SP用ページナビを作成
  const pageNaviSp = () => {
    const pageTxt = pagenation.querySelector('.js-pagenation--txt');
    pageTxt.textContent = `${currentPage} / ${max}`;
  }

  if(max === 1) {
    pagenation.remove();
  } else {
    pageNavi();
    pageNaviSp();
    arrow();
  }
}